import { Button, Col, Modal, Row } from "react-bootstrap";
import { NFeDto } from "../NFe.Dto";

interface Props {
  show: boolean;
  nfe: NFeDto | undefined;
  onReturn: () => void;
  onDelete: (value: NFeDto) => void;
  onPrint: (value: NFeDto) => void;
  onDownloadXml: (value: NFeDto) => void;
  onFetchStatus: (value: NFeDto) => void;
  onSend: (value: NFeDto) => void;
  onEdit: (value: NFeDto) => void;
  onDuplicate: (value: NFeDto) => void;
  onEvent: (value: NFeDto) => void;
  onVisualizar: (value: NFeDto) => void;
}

const NFeModalPropriedadesView = (props: Props) => {
  const finalizada = props.nfe?.autorizacao.codigoStatusResposta === 100;

  const onVisualizarHandler = () => {
    if (props.nfe) {
      props.onVisualizar(props.nfe);
    }
  };

  const onDeleteHandler = () => {
    if (props.nfe) {
      props.onReturn();
      props.onDelete(props.nfe);
    }
  };

  const onPrintHandler = () => {
    if (props.nfe) {
      props.onPrint(props.nfe);
    }
  };

  const onDownloadXmlHandler = () => {
    if (props.nfe) {
      props.onDownloadXml(props.nfe);
    }
  };

  const onDuplicateHandler = () => {
    if (props.nfe) {
      props.onDuplicate(props.nfe);
    }
  };

  const onFetchStatusHandler = () => {
    if (props.nfe) {
      props.onFetchStatus(props.nfe);
    }
  };

  const onReturnHanlder = () => {
    props.onReturn();
  };

  const onSendHandler = () => {
    if (props.nfe) {
      props.onSend(props.nfe);
    }
  };

  const onEditHandler = () => {
    if (props.nfe) {
      props.onEdit(props.nfe);
    }
  };

  const onEventHandler = () => {
    if (props.nfe) {
      props.onEvent(props.nfe);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col xs={6}>Número NFe: {props.nfe?.numeroNF}</Col>
            <Col xs={6}>Serie: {props.nfe?.serie}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Envio: {props.nfe?.autorizacao.codigoStatusEnvio}-
              {props.nfe?.autorizacao.descricaoStatusEnvio}
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              Status Resposta: {props.nfe?.autorizacao.codigoStatusResposta}-
              {props.nfe?.autorizacao.descricaoMotivoResposta}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onVisualizarHandler}
          >
            Visualizar
          </Button>
          {finalizada && (
            <>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onPrintHandler}
              >
                Imprimir
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onDownloadXmlHandler}
              >
                Baixar XML
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onDuplicateHandler}
              >
                Duplicar
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onEventHandler}
              >
                Eventos
              </Button>
            </>
          )}

          {!finalizada && (
            <>
              <Button
                variant="outline-danger"
                className="messagebox-btn-cancel"
                onClick={onDeleteHandler}
              >
                Excluir
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onFetchStatusHandler}
              >
                Consultar Situação
              </Button>
              <Button
                variant="outline-primary"
                className="messagebox-btn-cancel"
                onClick={onSendHandler}
              >
                Enviar
              </Button>
              <Button
                variant="outline-info"
                className="messagebox-btn-cancel"
                onClick={onEditHandler}
              >
                Alterar
              </Button>
            </>
          )}
          <Button
            variant="outline-primary"
            className="messagebox-btn-cancel"
            onClick={onReturnHanlder}
          >
            Sair
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default NFeModalPropriedadesView;
